import React from "react";
import { useModuleGate } from "../hooks/useModuleGate";
import UpgradePlan from "../Pages/UpgradePlan";

/**
 * Wraps a page component. If the user lacks ALL of the given module
 * access codes, renders UpgradePlan instead of the page content.
 *
 * Usage:
 *   <ModuleGate codes={[RECRUITMENT.VACANCIES_ALL]}>
 *     <AllVacancies />
 *   </ModuleGate>
 */
const ModuleGate = ({ codes = [], children }) => {
  const { hasAny } = useModuleGate();

  if (!hasAny(codes)) {
    return <UpgradePlan />;
  }

  return children;
};

export default ModuleGate;
